const messages = {
    availPoints: "Tillgängliga poäng",
    awaitingPoints: "Väntande poäng",
  board: {
    title: "Översikt",
    title2: "Prestandaanimation {year}",
    headline1: "Dina kampanjer och poäng i en överblick",
    headline2: "Tjäna poäng för dina däckköp.",
    pointsBalanceToDate: "POÄNGBALANS PER DATUM",
    availPoints: "Tillgängliga poäng",
    awaitingPoints: "Väntande poäng",
    yourRealisation: "DINA PRESTATIONER",
    yourEngagement: "Ditt årliga åtagande: <b>{tyres} däck</b>",
    yourPoints: "DINA POÄNG",
    yourRetailPurchase: "DINA DETALJKÖP",
    yourRetailPurchaseCCS: "DIN DETALJFÖRSÄLJNING",
    pointsByPurchase: "poäng genererade av dina köp",
    pointsByBoosters: "poäng genererade av boosters",
    pointsByBSPurchase: "Poäng genererade av dina Bridgestone-köp",
    pointsByBSPurchaseCCS:
      "Poäng genererade av din Bridgestone-däckförsäljning",
    remaining: "Kvarvarande däck",
    yourGoal: "Målframsteg",
    unit: "däck",
    buttons: {
      learnMore: "Läs mer om dina poäng",
      learnMoreAboutMechanism: "Lär dig mer om mekaniken",
    },
    charts: {
      byBrand: "Efter märke",
      bySize: "Efter fälg<br/>storlek",
    },
    exploreResults: "Upptäck dina resultat",
    tyreLimitInfo:
      "En minsta slutförsäljningsvolym på 50 Bridgestone- och/eller Firestone-däck krävs för varje Booster-kampanjperiod",
  },
  charts: {
    byBrand: "Efter märke",
    bySize: "efter fälgstorlek",
  },

  dashboard: {
    dashboardTitel: "Dina förmåner",
    dashboardBox: {
      title: "Poängbalans",
      description: "Dina nuvarande marknadsföringspoäng totalt",
      availPoints: "Tillgängliga poäng",
      awaitingPoints: "Väntande poäng",
      lastUpdate: "Senaste uppdatering",
      button: "Läs mer",
      points: "points",
    },
  },
  soldTyres: "DÄCK SÅLDA",
  receivedPoints: "TJÄNADE POÄNG",
  boosterCCS: {
    personalInfo: "Personlig information",
    csNumberTitle: "Vänligen ange deltagande kontonummer",
    tyresTitle: "Vänligen ange antalet sålda däck",
    minTyresInfo:
      "Ett minimum av __DÄCK__ Bridgestone/Firestone-däck krävs. Ersättningen gäller endast Bridgestone-däck.",
    tyresAmount: "Antal däck",
    filesTitle: "Ladda upp ditt försäljningsbevis",
    filesDescription:
      "Observera: endast försäljning som anger däcksfälgstorlek kommer att beaktas.",
    addAnotherFile: "Lägg till ett annat dokument",
    file: "Ladda upp dokument",
    formatInfo:
      "Godkända filformat: xlsx, jpeg och pdf. Maximal filstorlek: 8 MB",
    confrimationMessage:
      "<b>Tack för ditt deltagande!</b> <br/>Din förfrågan har tagits emot och vidarebefordrats till Bridgestone-team för validering.<br/>Du kommer att få ett e-postmeddelande med resultatet av ditt Booster CCS-deltagande.<br/>Vi ses snart på Bridgestone Plus!",
  },
  sharePointModal: {
    header: "Dela poäng",
    forShare: "Poäng du kommer att dela",
    title: "Titel",
  },
  notFoundFile: "Ingen vald",
  chooseFile: "Välj fil",
};
export default {
  messages,
};
